<template>
<div class="myIndex page_shopCenter">
    <div class="userInfo">
        <!-- 个人信息 -->
        <div class="user">
            <div class="user_top">
                <div class="user_left">
                    <div class="thumb" @click="goShopSet('/shop/set')">
						<img :src="info.thumb? ( $publicData.withHttpStart(info.thumb) ? info.thumb : imageUrl+info.thumb) : $publicData.defaultTouxiang" alt />
                    </div>
                    <div class="user_name slh_s">{{ info.nickname }}</div>
                </div>
                <div class="user_right">余额:￥{{ info.shop_money ? info.shop_money : 0}}</div>
            </div>
            <!-- 收藏 关注 粉丝 -->
            <div class="mark">
                <div class="item" @click="goPage('collect-index')">
                    <div class="num" v-if="info.nums">{{info.nums.collect}}</div>
                    <div class="txt">收藏</div>
                </div>
                <div class="item" @click="goPage('follow-index')">
                    <div class="num" v-if="info.nums">{{info.nums.attention}}</div>
                    <div class="txt">关注</div>
                </div>
                <div class="item" @click="goFensi">
                    <div class="num" v-if="info.nums">{{info.nums.attentioner}}</div>
                    <div class="txt">粉丝</div>
                </div>
            </div>
        </div>
    </div>
    <!--  -->
    <div class="con">
        <!-- 订单 -->
        <div class="order" :name="ordertab">
            <div class="top">
                <div class="tabs">
                    <span class="tab active" name="a" @click="changeTab('a')">商城订单</span>
					<!-- 不再区分云订单  2022年5月19日 -->
                    <!-- <span class="tab" name="b" @click="changeTab('b')">云订单</span> -->
                </div>
                <span class="more" @click="orderList(0)">全部订单</span>
            </div>
            <div class="nr">
                <div class="txt active" name="a">
                    <ul class="actions">
                        <li class="item" @click="orderList(1)">
                            <img :src="this.publicPath+'statics/images/my/icon_wallet.png'" class="item_icon" alt="">
                            <div class="item_txt">待支付</div>
                            <div class="num" v-if="token && unpay_num!=0">{{unpay_num}}</div>
                        </li>
                        <li class="item" @click="orderList(2)">
                            <img :src="this.publicPath+'statics/images/my/icon_fahuo.png'" class="item_icon" alt="">
                            <div class="item_txt">待发货</div>
                            <div class="num" v-if="token && unship_num!=0">{{unship_num}}</div>
                        </li>
                        <li class="item" @click="orderList(3)">
                            <img :src="this.publicPath+'statics/images/my/icon_shouhuo.png'" class="item_icon" alt="">
                            <div class="item_txt">待收货</div>
                            <div class="num" v-if="token && unreceipt_num!=0">{{ unreceipt_num }}</div>
                        </li>
                        <li class="item" @click="orderList(4)">
                            <img :src="this.publicPath+'statics/images/my/icon_comment.png'" class="item_icon" alt="">
                            <div class="item_txt">待评论</div>
                            <!-- <div class="num">12</div> -->
                        </li>
                        <!-- <li class="item" @click="orderList(5)">
                            <img :src="this.publicPath+'statics/images/my/icon_aftersale.png'" class="item_icon" alt="">
                            <div class="item_txt">售后</div>
                        </li> -->
                    </ul>
                </div>
                <div class="txt" name="b">
                    <ul class="actions">
                        <li class="item" @click="orderList(1)">
                            <img :src="this.publicPath+'statics/images/my/icon_wallet.png'" class="item_icon" alt="">
                            <div class="item_txt">待支付</div>
							<div class="num" v-if="token && unpay_num!=0">{{unpay_num}}</div>
                        </li>
                        <li class="item" @click="orderList(2)">
                            <img :src="this.publicPath+'statics/images/my/icon_fahuo.png'" class="item_icon" alt="">
                            <div class="item_txt">待发货</div>
							<div class="num" v-if="token && unship_num!=0">{{unship_num}}</div>
                        </li>
                        <li class="item" @click="orderList(3)">
                            <img :src="this.publicPath+'statics/images/my/icon_shouhuo.png'" class="item_icon" alt="">
                            <div class="item_txt">待收货</div>
							<div class="num" v-if="token && unreceipt_num!=0">{{ unreceipt_num }}</div>
                        </li>
                        <li class="item" @click="orderList(4)">
                            <img :src="this.publicPath+'statics/images/my/icon_comment.png'" class="item_icon" alt="">
                            <div class="item_txt">待评论</div>
                        </li>
                        <!-- <li class="item">
                            <img :src="this.publicPath+'statics/images/my/icon_aftersale.png'" class="item_icon" alt="">
                            <div class="item_txt">售后</div>
                        </li> -->
                    </ul>
                </div>
            </div>
        </div>
		<!-- 统计 -->
		<div class="list">
			<div class="title">统计</div>
			<div class="list_con tj">
				<div class="list_item">未完成订单金额统计： ￥{{ info.un_receive_money ? info.un_receive_money : 0 }}</div>
			</div>
		</div>
        <!-- 平台服务 -->
        <div class="list">
            <div class="title">店铺管理</div>
            <ul class="list_con clearfix">
                <li class="item f-l" @click="goTtradesmanCenter('/tradesman/center')">
                    <img :src="this.publicPath+ 'statics/images/my/center/01.png'" alt="" class="icon">
                    <div class="txt">账户中心</div>
                </li>
                <li class="item f-l" @click="routeLink('/tradesman/goods',{trad_uuid: info.uuid})">
                    <img :src="this.publicPath+ 'statics/images/my/center/02.png'" alt="" class="icon">
                    <div class="txt">商品管理</div>
                </li>
                <!-- <li class="item" @click="goPage('system-develop')">
                    <img :src="this.publicPath+ 'statics/images/my/center/03.png'" alt="" class="icon">
                    <div class="txt">直播申请</div>
                </li> -->
                <li class="item f-l" @click="goPage('tradesman-dingzhi')">
                    <img :src="this.publicPath+ 'statics/images/my/center/04.png'" alt="" class="icon">
                    <div class="txt">定制</div>
                </li>
                <li class="item f-l" @click="goShopSet('/shop/set')">
                    <img :src="this.publicPath+ 'statics/images/my/center/05.png'" alt="" class="icon">
                    <div class="txt">店铺设置</div>
                </li>
                <li class="item f-l" @click="goPage('tradesman-qrcode')">
                    <img :src="this.publicPath+ 'statics/images/my/center/06.png'" alt="" class="icon">
                    <div class="txt">二维码</div>
                </li>
                <li class="item f-l" @click="goTradesmanPartner(0)">
                    <img :src="this.publicPath+ 'statics/images/my/center/07.png'" alt="" class="icon">
                    <div class="txt">分销商</div>
                </li>
                <li class="item f-l" v-if="info.is_park!=1" @click="goTradesmanPartner(1)">
                    <img :src="this.publicPath+ 'statics/images/my/center/08.png'" alt="" class="icon">
                    <div class="txt">城市合伙人</div>
                </li>
                <li class="item f-l" @click="goLivingPage()">
                    <img :src="this.publicPath+ 'statics/images/my/center/09.png'" alt="" class="icon">
                    <div class="txt">直播</div>
                </li>
				<!-- 商家发布的定制 -->
				<li class="item f-l" @click="todingzhi()">
                    <img :src="this.publicPath+ 'statics/images/my/center/10.png'" alt="" class="icon">
                    <div class="txt">我发布的定制</div>
                </li>
				<!-- 商家定制订单列表 -->
				<li class="item hastag f-l" @click="goTradeDingzhiOrder">
                    <img :src="this.publicPath+ 'statics/images/my/center/11.png'" alt="" class="icon">
                    <div class="txt">定制订单</div>
					<div class="num" v-if="info.madeorder">{{ info.madeorder }}</div>
                </li>
                <!-- 图集 -->
				<li class="item f-l" @click="goPhoto">
                    <img :src="this.publicPath+ 'statics/images/my/center/13.png'" alt="" class="icon">
                    <div class="txt">图集</div>
                </li>
				<!-- 约看核销 -->
				<li class="item f-l" @click="scanHeXiao">
                    <img :src="this.publicPath+ 'statics/images/my/center/12.png'" alt="" class="icon">
                    <div class="txt">约看核销</div>
                </li>
				<!-- 推送管理 -->
				<li class="item f-l" @click="toPush">
                    <img :src="this.publicPath+ 'statics/images/my/center/02.png'" alt="" class="icon">
                    <div class="txt">推送管理</div>
                </li>
            </ul>
        </div>
    </div>
	<!-- 核销弹窗 -->
	<van-overlay :show="showHexiao" class-name="hexiao-overlay">
		<div class="hexiao-wrap">
			<img :src="publicPath+'/statics/images/my/yuekan-hexiao.png'" alt="" class="tips-tu">
			<div class="hexiao-tips">{{ hexiaoTips }}</div>
			<div class="hexiao-bottom" v-if="selectedTag == 2">
				<div class="action" @click="showHexiao = false">否</div>
				<div class="action" @click="hexiaoYuekan">是</div>
			</div>
			<div class="hexiao-bottom" v-if="selectedTag == 1" @click="showHexiao = false">知道了</div>
		</div>
	</van-overlay>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    name: "my-index",
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            ordertab: 'a',
            publicPath: process.env.BASE_URL,
            info: {}, // 用户信息
            token: null,
            tradesman_id: this.$route.query.tradesman_id, // 匠人id
			livingStatus: 0, //直播状态
			unpay_num: null, // 待支付订单数量
            unreceipt_num: null, // 待收货订单数量
			unship_num: null, // 待发货订单数量
			is_cloud: 0, // 0商城1云订单
			writeoffcode: this.$route.query.writeoffcode, // 约看核销码
			showHexiao: false,
			selectedTag: null, // 1显示一个按钮 2显示两个按钮
			hexiaoTips: '', // 核销提示文本
        };
    },
    created: function () {
		localStorage.removeItem('shopOrderStatus')
        //根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            var params = {
                data: {
                    naviTitle: "店铺中心"
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, data => {});
            //加载用户信息
            var memberParams = {
                'data': {
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                console.log('111')
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                    this.getAppleLivingStatus()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                if (this.token != null && this.token != undefined && this.token != '') {
                    this.getData()
                    this.getAppleLivingStatus()
                }
                // var voiceParams = {
                //     'data': {
                //         'close':'1'
                //     }
                // }
                // console.log('sdjy://public/orderSpeak')
                // this.$bridge.callhandler('sdjy://public/orderSpeak', voiceParams, (data) => {
                //     if (data.code == 200) {
                        
                //     }
                // })
                responseCallback('refresh success')
            })
        } else {
            this.isClient = false
            // 获取列表
            this.token = this.$store.getters.token
            this.getData();
			if(this.writeoffcode && this.tradesman_id){
				this.verfyYuekan();
			};
            this.getAppleLivingStatus();
        }
    },
    mounted: function () {
		
    },
    methods: {
        changeTab: function (str) {
            this.ordertab = str
            $('.order .tab').removeClass('active')
            $('.order .txt').removeClass('active')
            $('.order .tab[name=' + str + ']').addClass('active')
			$('.order .txt[name=' + str + ']').addClass('active')
			// 不再区分云订单  2022年5月19日
			// if (str == 'a') {
            //     this.is_cloud = 0
            // } else if (str == 'b') {
            //     this.is_cloud = 1
            // }
        },
        getData() {
            var param = {
                token: this.token,
				tradesman_id: this.tradesman_id,
				// is_cloud: this.is_cloud // 不再区分云订单  2022年5月19日
            }
            this.$api.tradesman.info(param).then(res => {
                if (res.code == 200) {
                    var info = res.result
                    // console.log(info)
					this.info = info
					var ordernum = res.result.ordernums
					this.unpay_num = ordernum.unpay_num.toString().length > 2 ? ordernum.unpay_num.toString().slice(0, 2) + '..' : ordernum.unpay_num.toString()
                    this.unreceipt_num = ordernum.unreceipt_num.toString().length > 2 ? ordernum.unreceipt_num.toString().slice(0, 2) + '..' : ordernum.unreceipt_num.toString()
                    this.unship_num = ordernum.unship_num.toString().length > 2 ? ordernum.unship_num.toString().slice(0, 2) + '..' : ordernum.unship_num.toString()
                } else {
                    this.$toast(res.message)
                }
            })
        },
        getAppleLivingStatus() {
            var param = {
                token: this.token,
            }
            this.$api.living.livingReview(param).then(res => {
                // console.log(res)
                if (res.code == 200) {
                    this.livingStatus = res.result
                } 
            })
        },
        getLivingData() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var param = {
                    token: this.token,
                }
                this.$api.living.myRoom(param).then(res => {
                    console.log(res)
                    if (res.code == 200) {
                        var data = res.result
                        var liveData = {}
                        liveData.username = data.tradesman.nickname
                        liveData.thumb = data.tradesman.thumb
                        liveData.swoole = data.swoole
                        liveData.roomid = data.roomid
                        liveData.closetime = data.close_room
                        liveData.url = data.push_url
                        var memberParams = {
                            'data': liveData
                        }
                        this.$bridge.callhandler('sdjy://public/living', memberParams, (data) => {
                            
                        })
                    } else {
                        this.$toast(res.message)
                    }
                })
                
            } else {
                this.$toast('请在客户端中打开进行直播')
            }
            
        },
        // 查看订单
        orderList(status) {
            if (this.isClient) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl + '/tradesman/order?status=' + status + '&sorce=' + (this.ordertab == 'a' ? '0' : '1')+'&uuid='+this.info.uuid+'&is_platprice='+(this.info.is_park ? 2 : 0)
                            }
                        }
                        console.log(params)
                        console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                this.$router.push({
                    path: '/tradesman/order',
                    query: {
                        status: status,
                        sorce: this.ordertab == 'a' ? '0' : '1', 
                        is_platprice: this.info.is_park ? 2 : '0'
                    }
                })
            }
        },
        // 页面跳转
        goPage(name) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        name = name.replace("-", "/")
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl+'/' + name
                            }
                        }
                        console.log(params)
                        console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                if (!this.$store.getters.token) {
					localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
                    this.$router.push({
                        path: '/login',
                        // query: {
                        //     redirect: this.$router.currentRoute.fullPath
                        // }
                    })
                    return
                }
                this.$router.push({
                    name: name
                })
            }
        },
        // 粉丝
		goFensi(){
			var that = this
            console.log(that.info)
			that.$router.push({
				path: '/fans/index',
				query: {
					tradesman_uuid : that.info.uuid
				}
			})
		},
        todingzhi() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl+'/' + 'tradesman/dingzhi/self'
                            }
                        }
                        console.log(params)
                        console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                if (!this.$store.getters.token) {
					localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
                    this.$router.push({
                        path: '/login',
                        // query: {
                        //     redirect: this.$router.currentRoute.fullPath
                        // }
                    })
                    return
                }
                this.$router.push({
                    name: 'tradesman-dingzhi-self'
                })
            }
        },
        goLivingPage() {
            console.log(this.livingStatus)
            if (this.livingStatus == 2) {
                this.getLivingData()
                return
            }
            var name = 'zhibo-apply'
            if (this.livingStatus == 1) {
                name = 'zhibo-applying'
            }
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        name = name.replace("-", "/")
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl+'/' + name
                            }
                        }
                        console.log(params)
                        console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                if (!this.$store.getters.token) {
					localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
                    this.$router.push({
                        path: '/login',
                        query: {
                            redirect: this.$router.currentRoute.fullPath
                        }
                    })
                    return
                }
                this.$router.push({
                    name: name
                })
            }
        },
        
        // 店铺设置
        goShopSet(path) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl + path + `?tradesman_id=${this.tradesman_id}`
                            }
                        }
                        console.log(params)
                        console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                if (!this.$store.getters.token) {
					localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
                    this.$router.push({
                        path: '/login',
                        // query: {
                        //     redirect: this.$router.currentRoute.fullPath
                        // }
                    })
                    return
                }
                this.$router.push({
                    path: path,
                    query: {
                        tradesman_id: this.tradesman_id
                    }
                })
            }
        },
        // 代理商 合伙人
        goTradesmanPartner(status) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl + '/tradesman/partner' + `?status=${status}`
                            }
                        }
                        console.log(params)
                        console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                this.$router.push({
                    path: '/tradesman/partner',
                    query: {
                        status: status
                    }
                })
            }
        },
        goTtradesmanCenter(path) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl + path + `?tradesman_id=${this.tradesman_id}`
                            }
                        }
                        console.log(params)
                        console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                this.$router.push({
                    path: path,
                    query: {
                        tradesman_id: this.tradesman_id
                    }
                })
            }
            
		},
		// 商家定制订单列表
		goTradeDingzhiOrder(){
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl + '/tradesman/dingzhi/order'
                            }
                        }
                        console.log(params)
                        console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                this.$router.push({
                    path: '/tradesman/dingzhi/order'
                })
            }
		},
        goPhoto() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl + '/tradesman/photo'
                            }
                        }
                        console.log(params)
                        console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                this.$router.push({
                    path: '/tradesman/photo'
                })
            }
        },
		/**
		 * @name: 验证门票是否可以核销
		 * @return {*}
		 * @desc: 
		 */		
		verfyYuekan(){
			let params = {
				token: this.token,
				tradesman_id: this.tradesman_id,
				writeoffcode: this.writeoffcode
			};
			this.$api.live.verfyOrder(params).then(res=>{
				if(res.code == 200){
					this.showHexiao = true;
					this.selectedTag = 2;
					this.hexiaoTips = res.message;
				}else if(res.code == 201){
					this.showHexiao = true;
					this.selectedTag = 1;
					this.hexiaoTips = res.message;
				}else if (res.code == 202){
					this.showHexiao = true;
					this.selectedTag = 2;
					this.hexiaoTips = res.message;
				}else{
					this.$toast(res.message);
				}
			})
		},
		/**
		 * @name: 约看核销
		 * @return {*}
		 * @desc: 
		 */		
		hexiaoYuekan(){
			let params = {
				token: this.token,
				tradesman_id: this.tradesman_id,
				writeoffcode: this.writeoffcode
			};
			this.$api.live.wirteoffOrder(params).then(res=>{
				if(res.code == 200){
					this.showHexiao = false;
					this.$toast(res.message);
				}else{
					this.showHexiao = false;
					this.$toast(res.message);
				}
			})
		},
		/**
		 * @name: 调起二维码
		 * @return {*}
		 * @desc: 
		 */		
		scanHeXiao(){
			let that = this;
			wx.scanQRCode({
				needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
				scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
				success: function(res) {
					console.log('扫码成功res',res);
					// var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
					// console.log(result);
					let result = res.resultStr;
					let params = that.getUrlParams(result);
					if(params.tradesman_id && params.writeoffcode){
						that.tradesman_id = params.tradesman_id;
						that.writeoffcode = params.writeoffcode;
						that.verfyYuekan();
					}else{
						that.$toast('二维码有误，请联系相关人员')
					}
				},
				fail: function(err) {
					that.$toast('扫码失败');
					console.log('调扫码失败，'+ err)
				}
			});
		},
		/**
		 * @name: 获取url中的参数
		 * @param {*} url
		 * @return {*}
		 * @desc: 
		 */		
		getUrlParams(url){
			let theRequest = new Object();
			if(url.indexOf('?') != -1){
				let index = url.indexOf('?');
				let params = url.slice(index+1,url.length);
				let paramsArr = params.split('&');
				for (let i = 0; i < paramsArr.length; i++) {
                    theRequest[paramsArr[i].split("=")[0]] = paramsArr[i].split("=")[1];
                }
			};
			return theRequest;
		},
		/**
		 * @name: 去推送页
		 * @return {*}
		 * @desc: 
		 */		
		toPush(){
			this.$router.push({
				path: "/tradesman/push",
				query: {
					trad_uuid: this.info.uuid
				}
			})
		},
		/**
		 * @name: 路由跳转
		 * @param {*} path
		 * @param {*} ojb
		 * @return {*}
		 * @desc: 
		 */		
		routeLink(path,obj){
			this.$router.push({
				path: path,
				query: obj
			})
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
	.myIndex .list .list_con{
		display: flex;
    	flex-wrap: wrap;
	}
</style>
